module.exports = __webpack_public_path__ + "files/264c256f4b44367a49aea5d2f9e6d2f6.png";